import { render } from "./VipShow.vue?vue&type=template&id=330987d6&scoped=true"
import script from "./VipShow.vue?vue&type=script&lang=js"
export * from "./VipShow.vue?vue&type=script&lang=js"

import "./VipShow.vue?vue&type=style&index=0&id=330987d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330987d6"]])

export default __exports__